"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var Cookies = __importStar(require("js-cookie"));
var react_1 = __importStar(require("react"));
var bundle_items_1 = __importDefault(require("../../apps/account-v3/sections/edit-bundle/components/bundle-items"));
var format_price_1 = __importDefault(require("../../utils/format-price"));
var BundleCartItem = function (_a) {
    var item = _a.item, removeFromCart = _a.removeFromCart, expanded = _a.expanded, allowActions = _a.allowActions;
    var _b = __read((0, react_1.useState)(expanded), 2), areBundleDetailsExpanded = _b[0], setBundleDetailsExpanded = _b[1];
    if (!item.children)
        return null;
    var getItemTitleAndOptions = function (bundleItem) {
        if (bundleItem.title.includes("Bundle Diaper Patterns") || bundleItem.title.includes('Bundle Training Pant Patterns')) {
            return { title: bundleItem.variant_options[1], optionName: "Size ".concat(bundleItem.variant_options[0]) };
        }
        return { title: bundleItem.product_title.replace(/\(.*\)/, ''), optionName: bundleItem.variant_options.filter(function (o) { return o.toLowerCase() !== 'default title'; }).join(' /') };
    };
    var showNewPricing = !Cookies.get('abPreviousBundlePricing');
    var _c = (0, react_1.useMemo)(function () {
        var _a;
        var bundleType = (function (bundleItem) {
            switch (bundleItem.product_title) {
                case 'Vitamin Bundle':
                    return 'Vitamin';
                case 'Training Pants Bundle':
                    return 'Training Pant';
                case 'Essentials Bundle':
                case 'Fundamentals Bundle':
                    return 'Fundamentals';
                default:
                    return 'Diaper';
            }
        })(item.item);
        var isDiaperBundleItem = function (cartItem) {
            if (!['Diaper', 'Training Pant'].includes(bundleType))
                return false;
            return cartItem.title.includes('Diaper Patterns') || cartItem.title.includes('Bundle Training Pant Patterns') || cartItem.title === '(Bundle) Wipes';
        };
        var _b = (item.children || []).reduce(function (_a, childItem) {
            var bundleItems = _a.bundleItems, addOns = _a.addOns, freebie = _a.freebie;
            if (isDiaperBundleItem(childItem) || !['Diaper', 'Training Pant'].includes(bundleType))
                bundleItems.push(childItem);
            else if (['Diaper', 'Training Pant'].includes(bundleType) && Number(childItem.price === 0))
                freebie = childItem;
            else
                addOns.push(childItem);
            // if (bundleType === 'Diaper' || bundleType === 'Training Pant' && childItem.title.includes('Bundle Diaper Patterns')) bundleItems.push(childItem)
            // elsif (bundleType === 'Diaper' || bundleType === 'Training Pant' && Number(childItem.price === 0)) freebie = childItem
            // else addOns.push(childItem)
            return { bundleItems: bundleItems, addOns: addOns, freebie: freebie };
        }, { bundleItems: [], addOns: [], freebie: undefined }), bundleItems = _b.bundleItems, addOns = _b.addOns, freebie = _b.freebie;
        var calculatedOriginalBundleValue = bundleType === 'Fundamentals' || bundleType === 'Vitamin' ? Number((_a = item.item.properties) === null || _a === void 0 ? void 0 : _a.original_bundle_value) : 0;
        var calculatedBundleItems = bundleItems
            .sort(function (a, b) { return (a.title.includes('Diaper Patterns') || a.title.includes('Training Pant Patterns') ? -2 : 1); })
            .map(function (c) {
            var _a = getItemTitleAndOptions(c), title = _a.title, optionName = _a.optionName;
            return {
                title: title,
                imgSrc: c.image,
                quantity: c.quantity,
                optionName: optionName,
                isOOS: false,
                isLowStock: false,
            };
        });
        var calculatedFreebieItem = (function () {
            if (!freebie)
                return undefined;
            var _a = getItemTitleAndOptions(freebie), title = _a.title, optionName = _a.optionName;
            return { title: title, imgSrc: freebie.image, quantity: freebie.quantity, optionName: optionName };
        })();
        var calculatedAddOnItems = addOns.map(function (addOn) {
            var _a, _b;
            var _c = getItemTitleAndOptions(addOn), title = _c.title, optionName = _c.optionName;
            return {
                title: title,
                imgSrc: addOn.image,
                quantity: addOn.quantity,
                optionName: optionName,
                isOOS: false,
                isLowStock: false,
                price: addOn.price / 100,
                compareAtPrice: ((_a = addOn.properties) === null || _a === void 0 ? void 0 : _a.compare_at_price) ? Number((_b = addOn.properties) === null || _b === void 0 ? void 0 : _b.compare_at_price) / 100 : undefined,
            };
        });
        var calculatedBundleTotal = Number(item.item.price) + bundleItems.reduce(function (sum, i) { return sum + Number(i.price) * i.quantity; }, 0);
        var calculatedBundleVariantOptions = item.item.variant_options.filter(function (o) { return !o.toLowerCase().includes('default'); });
        return {
            originalBundleValue: calculatedOriginalBundleValue,
            bundleItems: calculatedBundleItems,
            bundleTotal: calculatedBundleTotal,
            bundleVariantOptions: calculatedBundleVariantOptions,
            freebieItem: calculatedFreebieItem,
            addOnItems: calculatedAddOnItems,
        };
    }, [item]), originalBundleValue = _c.originalBundleValue, bundleItems = _c.bundleItems, bundleTotal = _c.bundleTotal, bundleVariantOptions = _c.bundleVariantOptions, freebieItem = _c.freebieItem, addOnItems = _c.addOnItems;
    var _d = __read(addOnItems.reduce(function (_a, addOnItem) {
        var _b = __read(_a, 2), sumTotal = _b[0], sumCompareAtTotal = _b[1];
        return [
            sumTotal + Math.ceil(Number(addOnItem.price) * 100),
            sumCompareAtTotal + Math.ceil((addOnItem.compareAtPrice || addOnItem.price || 0) * 100),
        ];
    }, [0, 0]), 2), addOnTotal = _d[0], addOnCompareAtTotal = _d[1];
    var totalSaved = originalBundleValue + addOnCompareAtTotal - addOnTotal;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'position-relative cart-drawer__item-container margin-top-2 bg-white bordered border-very-light-pink', key: item.item.key },
            react_1.default.createElement("div", { className: 'cart-drawer__item padding-4' },
                react_1.default.createElement("div", { className: 'cart-drawer__item-img-container' },
                    react_1.default.createElement("img", { alt: item.item.title, src: item.item.image })),
                react_1.default.createElement("div", { className: 'cart-drawer__item-info-container' },
                    allowActions && (react_1.default.createElement("button", { className: 'float-right cart-drawer__item--remove', onClick: function () { return removeFromCart(item); } },
                        react_1.default.createElement("img", { src: window.cartSettings.closeImageUrl }))),
                    react_1.default.createElement("div", { className: 'font-size-14 font-weight-500' },
                        " ",
                        item.item.product_title,
                        " "),
                    !!bundleVariantOptions.length && react_1.default.createElement("div", { className: (0, classnames_1.default)('bundle-item-block--option-name') }, bundleVariantOptions.join(' / ')),
                    !showNewPricing && (react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: 'margin-top-2 margin-bottom-2 font-size-12 font-weight-500' },
                            (0, format_price_1.default)(bundleTotal + addOnTotal),
                            " per shipment"),
                        totalSaved > 150 && react_1.default.createElement("div", { className: 'margin-top-2 font-size-12 text-brownish-grey' },
                            "Your bundle savings are ",
                            (0, format_price_1.default)(totalSaved)))),
                    showNewPricing && (react_1.default.createElement("div", { className: 'margin-top-2 margin-bottom-2 font-size-12 font-weight-500' },
                        !!originalBundleValue && Number(bundleTotal) - Number(originalBundleValue) > 5 && react_1.default.createElement("span", { className: 'strike' }, (0, format_price_1.default)(originalBundleValue)),
                        ' ',
                        react_1.default.createElement("span", { className: 'text-soft-purple' },
                            (0, format_price_1.default)(bundleTotal),
                            " per shipment"))),
                    showNewPricing && !!addOnItems.length && (react_1.default.createElement("div", { className: 'margin-top-2 margin-bottom-2 font-size-12 font-weight-500 text-brownish-grey' },
                        react_1.default.createElement("div", null,
                            "Add Ons ",
                            react_1.default.createElement("i", null, "(15% off)")),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("span", { className: 'text-brownish-grey' }, (0, format_price_1.default)(addOnTotal)),
                            "\u00A0",
                            addOnCompareAtTotal - addOnTotal > 0 && react_1.default.createElement("span", { className: 'strike' }, (0, format_price_1.default)(addOnCompareAtTotal))))))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)('cart--bundle-details', { expanded: areBundleDetailsExpanded, collapsed: !areBundleDetailsExpanded }) },
                react_1.default.createElement(bundle_items_1.default, { items: bundleItems }),
                freebieItem && (react_1.default.createElement("div", null,
                    react_1.default.createElement("h5", { className: 'font-size-14 font-weight-500 margin-top-4 bundle-item-block' }, "Your Freebie"),
                    react_1.default.createElement(bundle_items_1.default, { items: [freebieItem], hideQuantity: true }))),
                !!addOnItems.length && (react_1.default.createElement("div", null,
                    react_1.default.createElement("h5", { className: 'font-size-14 font-weight-500 margin-top-4 bundle-item-block' }, "Add-ons"),
                    react_1.default.createElement(bundle_items_1.default, { items: addOnItems })))),
            react_1.default.createElement("div", { className: 'cart-drawer__bundle--item--show-more-less display-block text-center font-size-12' },
                react_1.default.createElement("button", { onClick: function () { return setBundleDetailsExpanded(true); }, className: (0, classnames_1.default)({ hide: areBundleDetailsExpanded }) },
                    "See Bundle Details ",
                    react_1.default.createElement("img", { src: window.cartSettings.arrowDownIconURL })),
                react_1.default.createElement("button", { onClick: function () { return setBundleDetailsExpanded(false); }, className: (0, classnames_1.default)({ hide: !areBundleDetailsExpanded }) },
                    "Hide Bundle Details ",
                    react_1.default.createElement("img", { src: window.cartSettings.arrowUpIconURL }))))));
};
exports.default = BundleCartItem;
